import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import UserModal from 'components/UserModal/component';

export default styled(UserModal)`
  padding: ${gridSizes('L')};
  padding-bottom: 0px;

  ${media.lessThan('extraSmall')`
    padding: ${gridSizes('M')};
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #fff;
  `};

  .field-container {
    margin-bottom: ${gridSizes('M')};
    position: relative;
  }

  button:last-child {
    margin-top: ${gridSizes('M')};
  }
`;
